import axiosPublic from "../axiosPublic";
import { getTokenDetails } from "../authToken";

export const tryRefreshToken = async () => {
    let tokenDetails = getTokenDetails();
    const accessToken = tokenDetails.accessToken;
    const refreshToken = tokenDetails.refreshToken;
    return await axiosPublic.post('/auth/refreshtoken', {
        accessToken: accessToken,
        refreshToken: refreshToken
    });
};